'use client';

import {
  createContext,
  useContext,
  ReactNode,
  Dispatch,
  useReducer,
  useMemo,
} from 'react';
import reducer from './reducer';
import { Action } from './action.type';
import { initialState, State } from './state';

type ContextValue = {
  state: State;
  dispatch: Dispatch<Action>;
};

type AppProviderProps = {
  children: ReactNode;
};

const AppContext = createContext<ContextValue>({
  state: initialState,
  dispatch: () => undefined,
});
const useAppContext = () => useContext(AppContext);

const AppProvider = ({ children }: AppProviderProps) => {
  const [state, dispatch] = useReducer(reducer, { ...initialState });

  const appContext = useMemo(
    () => ({
      state,
      dispatch,
    }),
    [state, dispatch]
  );

  return (
    <AppContext.Provider value={appContext}>{children}</AppContext.Provider>
  );
};

export { AppProvider, useAppContext };
